// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IpZX","colBig":"styles_colBig__ebndi","colSmall":"styles_colSmall__2KdyR"};